export default __webpack_public_path__ + "static/media/device-BL-128x128.d5b578ff.png";